<template>
  <div class="business">
    hiiiiiiiiiiiiiii
    <div class="top-bar">
      <span @click="backToBu">
        <i class="left"></i>
      </span>
      <span class="heading_new">View Slabs</span>
    </div>

    <div class="margin-t-l" v-for="(slab,index) in rangeslabArray" :key="index">
      <span>
        <div class="flex-box">
          <div class="row-container">
            <b>Slab {{index+1}}</b>
          </div>
          <div class="row-container" v-if="rangeslabArray.length">
            <img class="margin-r-m" src="@/assets/delete.svg" />
            <button class="text-green" @click="deleterangeslab(index)">Delete Slab</button>
          </div>
        </div>
      </span>
      <br />
      <div class="range">
        <txt
          label="Min Value of Range"
          type="text"
          class="margin-r-s width-18per"
          v-model="slab.from"
          :name="`Minvalue for Slab ${index+1}`"
          v-validate="`required_if:${rangeslabArray.length}|max_value:${parseInt(slab.to)}|min_value:0`"
          @onValueChange="save"
          :classname="errors.has(`Minvalue for Slab ${index+1}`)"
          :errormsg="errors.first(`Minvalue for Slab ${index+1}`)"
        />
        <txt
          label="Max Value of Range"
          type="text"
          class="margin-r-s width-18per"
          v-model="slab.to"
          :name="`Maxvalue for Slab ${index+1}`"
          v-validate="`required_if:${rangeslabArray.length}|max_value:${parseInt(slab.to)}|min_value:0`"
          @onValueChange="save"
          :classname="errors.has(`Maxvalue for Slab ${index+1}`)"
          :errormsg="errors.first(`Maxvalue for Slab ${index+1}`)"
        />
      </div>
      <div class="range">
        <txt
          label="City"
          type="text"
          class="margin-r-s width-18per"
          v-model="slab.city"
          name="City"
          v-validate="'required'"
          @onValueChange="save"
          :classname="errors.has('City')"
          :errormsg="errors.first('City')"
        />
        <txt
          label="Salary Component Value"
          type="text"
          class="margin-r-s width-18per"
          v-model="slab.value"
          name="Salary Component Value"
          v-validate="'required'"
          @onValueChange="save"
          :classname="errors.has('Salary Component Value')"
          :errormsg="errors.first('Salary Component Value')"
        />
      </div>
      <div class="flex-box align-center margin-tb-l">
        <div class="row-container">
          <img src="@/assets/group-5.svg" />
          <button class="text-green" @click="addrangeslab()">Make New Slab</button>
        </div>
      </div>
    </div>
    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Save" type="primary" @click="save" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: "addSlabs",
  data() {
    return {
      rangeslabArray: [],
      errmsg: "",
      toast: false,
      showSuccessMsg: false
    };
  },
  computed: {
    ...mapState("onboard/organization", {
      orgId: state => state.id
    })
  },

  methods: {
    ...mapActions({
      act_create: "onboard/business_units/create",
      act_update: "onboard/business_units/update",
      act_create_butype: "onboard/butypes/create"
    }),

    addrangeslab() {
      //console.log("rangeslabArray", this.rangeslabArray);
      this.rangeslabArray.push({
        from: "",
        to: "",
        city: "",
        salaryCompValue: ""
      });
    },

    deleterangeslab(index) {
      this.rangeslabArray.splice(index, 1);
    },

    async saveBuType() {
      if (!this.$_.isEmpty(this.buTypeFormData.buTypeName)) {
        try {
          let obj = {
            data: {
              name: this.buTypeFormData.buTypeName,
              description: this.buTypeFormData.description,
              org_id: this.orgId
            }
          };
          this.$root._data.isSaving = true;
          let res = await this.act_create_butype(obj);
          setTimeout(() => {
            if (res.data.statusCode == 200 || res.data.statusCode == 201) {
              this.showBUTypeSuccessMsg = true;
              this.showAddBUtype = false;
              this.formData.buTypeObj = null;
            }
            this.$root._data.isSaving = false;
          }, 500);
        } catch (err) {
          this.$root._data.isSaving = false;
          this.toast = true;
          this.errmsg = err; //err.message;
        }
      } else {
        this.toast = true;
        this.errmsg = "Please enter BU Type Name";
      }
    },

    backToBu() {
      this.showSuccessMsg = false;
      this.refresh();
      this.$router.go(-1);
    },
    refresh() {
      this.$validator.reset();
      this.formData = {
        name: "",
        description: "",
        buTypeObj: null,
        parentBuObj: null,
        uploadMethod: this.formData.uploadMethod
      };
      this.formData.buTypeObj = null;
      this.formData.buTypeID = null;
      this.showAddBUtype = false;
    },
    continuee() {
      this.$router.push({
        path: `/onboarding/entity/summary`
      });
    },
    cancel() {
      this.$router.push({
        path: "/onboarding/business_units"
      });
      this.showAddBUtype = false;
    },
    changeItem(event) {
      this.selectedLocationType = event.target.value;
      //console.log("item changed", this.selectedLocationType);
      if (this.selectedLocationType == "Add Business Unit Type") {
        this.showForm = true;
      }
    },
    async performAction() {
      //console.log("formData:", this.formData);

      if (!this.$_.isEmpty(this.formData.name)) {
        //&& !this.$_.isEmpty(this.formData.type
        try {
          if (this.editMode) {
            let obj = {
              data: {
                org_id: this.orgId,
                name: this.formData.name,
                type: this.formData.buTypeObj
                  ? this.formData.buTypeObj.id
                  : null,
                description: this.formData.description,
                active: true,
                parentID: this.formData.parentBuObj
                  ? this.formData.parentBuObj.id
                  : null,
                id: this.record.id
              }
            };

            this.$root._data.isSaving = true;
            await this.act_update(obj);
            setTimeout(() => {
              this.$router.go(-1);
              this.$root._data.isSaving = false;
            }, 500);
          } else {
            let obj = {
              data: {
                org_id: this.orgId,
                name: this.formData.name,
                type: this.formData.buTypeObj
                  ? this.formData.buTypeObj.id
                  : null,
                description: this.formData.description,
                active: true,
                parentID: this.formData.parentBuObj
                  ? this.formData.parentBuObj.id
                  : null
              }
            };

            this.$root._data.isSaving = true;
            await this.act_create(obj);
            setTimeout(() => {
              this.$root._data.isSaving = false;
              this.$router.go(-1);
            }, 500);
          }
        } catch (err) {
          this.$root._data.isSaving = false;
          this.toast = true;
          this.errmsg = err;
          //console.log("error:", err);
        }
      } else {
        this.toast = true;
        this.errmsg = "Please enter BU Name";
      }
    },
    async save() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.performAction();
        }
      });
    },
    async addBuType(record) {
      //console.log("record", record);
      let obj = {
        data: [
          {
            ...record,
            org_id: this.orgId
          }
        ]
      };
      try {
        this.$root._data.isSaving = true;
        await this.act_create_butype(obj);
        setTimeout(() => {
          this.$root._data.isSaving = false;
          this.showForm = false;
        }, 500);
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err.message;
      }
    },

    backToaddBusinessUnit() {
      this.showBUTypeSuccessMsg = false;
      this.buTypeFormData = {
        buTypeName: "",
        description: ""
      };
      this.formData.type = null;
      this.formData.buTypeObj = null;
      this.formData.buTypeID = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.bottom-75 {
  margin-bottom: 75px;
}
.text {
  width: 622px;
  height: 74px;
  font-family: Montserrat;
  font-size: 14px;
  color: #9c9c9c;
}

.content-new {
  margin: 20px;
  .errorr {
    border: 1px solid #e01717;
  }
  .errorMessage {
    color: #e01717; // padding-top: 1px
  }
}

footer {
  height: 50px;
  flex-shrink: 0;
}

.business {
  width: 100%;
  height: 100%;
}

.business .top-bar {
  padding: 32px;
}

.heading_new {
  width: auto;
  font-family: Montserrat;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
}

.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}

.refresh-icon {
  cursor: pointer;
}

.errorr {
  border: 1px solid #e01717;
}

.errorMessage {
  color: #e01717; // padding-top: 1px
}

.selectdiv select {
  width: 300px;
  height: 35px;
  border-radius: 4px;
  outline: 0;
  font-size: 14px;
  color: black;
  border: 1px solid #a7a7a7;
  padding: 0 10px;
  /* needed */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* SVG background image */
  /* background: url("@/assets/stroke-1.png"); */
  background-size: 12px;
  background-position: calc(100% - 10px) center;
  background-repeat: no-repeat;

  &:focus {
    outline: none;
    border: 2px solid #37c6c0;
  }
}

select .dropdown {
  border-radius: 4px;
  border: 1px solid #dadada;
  padding: 10px;
  width: 93px;
  height: 35px;
  transition: ease-in-out, width 0.35s ease-in-out;

  &:focus {
    outline: none;
    border: 2px solid #37c6c0;
  }
}
.line {
  margin-left: 4px;
  margin-bottom: 5px;
  margin-top: 18px;
  margin-right: 30px;
  border-bottom: 1px solid #34c0be;
}

.contbtn {
  margin-top: 30px;
  float: right;
  margin-right: 30px;
  width: 154px;
  height: 45px;
  border-radius: 4px;
  box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
  background-color: #5d409f;
  color: #ffffff;
}

.form-button {
  margin-top: 10px;
  margin-bottom: 5%;
}

.custom-width {
  width: 300px;
}

.upload {
  display: flex;
  width: 30%;
  margin-top: 2%;
  align-items: flex-start;
  flex-direction: column;
  background: none;
  background-position: top, right, bottom, left;
  background-repeat: repeat-x, repeat-y;
  background-size: 20px 1px, 1px 20px;
  height: 140px;
}

.upload-button {
  display: flex;
  align-items: center;
  label {
    cursor: pointer;
    border: 1px solid #5d409f;
    border-radius: 4px;
    padding: 6px 12px;
    font-size: 15px;
    color: #5d409f;
  }
  #upload-photo {
    opacity: 0;
    position: absolute;
    z-index: -1;
  }
  img {
    height: 19px;
    width: 19px;
    margin-right: 8px;
  }
}

.content-new {
  margin: 32px;
}

.addBUbox {
  width: 100%;
  padding: 25px;
  height: 300px;
  background-color: #f9f9f9;
  .custom-btn {
    width: auto;
    height: 45px;
    border-radius: 4px;
    box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
  }
}
</style>
